"use client";

import { ApiCatalog } from "@/api/catalog";
import { ApiCollections } from "@/api/collection";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";
import { useStore } from "@/hooks/system/useStore";
import { useParams, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const useCollectionData = () => {
  const params = useParams();
  const { id } = params;
  const isIdValid = typeof id === "string" && !Number.isNaN(+id);

  const searchParams = useSearchParams();

  const { setSelectedFilters, selectedFilters } = useStore("collection");

  const { data: detailCollection, isLoading: detailCollectionLoading } = useLocalizedQuery({
    queryKey: ["collection", +id],
    queryFn: async lang => ApiCollections.getCollection(+id, lang),
  });

  const firstCategory = detailCollection?.categories?.[0].id;
  const isProductsQueryEnabled = isIdValid && !!selectedFilters.category_id;

  useEffect(() => {
    const categoryId = searchParams.get("category");
    const page_number = searchParams.get("page_number");

    setSelectedFilters({
      page_number: page_number ? +page_number : 1,
      page_size: 9,
      category_id: categoryId ? +categoryId : firstCategory,
    });
  }, [id, searchParams, setSelectedFilters, firstCategory]);

  const { data: products, isFetching: productsLoading } = useLocalizedQuery({
    queryKey: ["products", selectedFilters.category_id, selectedFilters.page_number, selectedFilters.page_size, +id],
    options: {
      enabled: isProductsQueryEnabled,
    },
    queryFn: lang =>
      ApiCatalog.getProducts(lang, {
        ...selectedFilters,
        colors: [],
        category_ids: [],
        collection_ids: [+id],
      }),
  });

  return {
    detailCollection: { detailCollection, loading: detailCollectionLoading },
    products: { products, loading: productsLoading },
  };
};
